import { render, staticRenderFns } from "./GChatRightSidebar.vue?vue&type=template&id=59be08ad&scoped=true&"
import script from "./GChatRightSidebar.vue?vue&type=script&lang=js&"
export * from "./GChatRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GChatRightSidebar.vue?vue&type=style&index=0&id=59be08ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be08ad",
  null
  
)

export default component.exports